export enum ResearchDashboardProp {
  RecentResearch = 'recentResearch',
  RecentlyUpdatedProfiles = 'recentlyUpdatedProfiles',
  RecentlyEnhancedProfiles = 'recentlyEnhancedProfiles',
  AnalystNotes = 'analystNotes',
  SpecialReports = 'specialReports',
  TrackRecord = 'trackRecord',
}
